import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { Button } from '@retailsync/ui'
import {
  UserIcon,
  Cog6ToothIcon,
  ArrowRightOnRectangleIcon,
  Bars3Icon,
} from '@heroicons/react/24/outline'

interface ConnectorHeaderProps {
  /** Opens the off-canvas navigation below the `lg` breakpoint. */
  onOpenNav: () => void
}

export function ConnectorHeader({ onOpenNav }: ConnectorHeaderProps) {
  const { user, tenant, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="bg-white border-b border-gray-200 px-4 sm:px-6 py-3 sm:py-4">
      <div className="flex items-center justify-between gap-3">
        {/* Menu (mobile only) + Title */}
        <div className="flex items-center gap-3 min-w-0">
          <button
            onClick={onOpenNav}
            className="lg:hidden p-2 -ml-2 rounded-md text-gray-600 hover:bg-gray-100"
            aria-label="Open navigation"
          >
            <Bars3Icon className="h-6 w-6" />
          </button>
          <div className="min-w-0">
            <h1 className="text-lg sm:text-2xl font-bold text-gray-900 truncate">Universal Connector</h1>
            <p className="text-xs sm:text-sm text-gray-600 truncate">
              Import data from any POS system
              {tenant && <span className="ml-2 text-primary-600 font-medium">— {tenant.name}</span>}
            </p>
          </div>
        </div>

        {/* User Actions */}
        <div className="flex items-center space-x-2 sm:space-x-4 shrink-0">
          {/* User Info — hidden on phones, shown from sm up */}
          {user && (
            <div className="hidden sm:flex items-center space-x-2 text-sm text-gray-600">
              <UserIcon className="h-5 w-5" />
              <span>{user.full_name || user.email}</span>
            </div>
          )}

          {/* Settings */}
          <Button variant="ghost" size="sm" onClick={() => navigate('/settings')}>
            <Cog6ToothIcon className="h-5 w-5" />
          </Button>

          {/* Logout */}
          <Button variant="ghost" size="sm" onClick={handleLogout}>
            <ArrowRightOnRectangleIcon className="h-5 w-5" />
          </Button>
        </div>
      </div>
    </header>
  )
}